import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { Capacitor } from '@capacitor/core';

class CrashlyticsService {
  async setUserId(userId: number) {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    if (userId) {
      await FirebaseCrashlytics.setUserId({
        userId: userId.toString(),
      });
    }
  }
}

export const crashlyticsService = new CrashlyticsService();
